<template lang="pug">
.mask
  .loading_wrapper.flex_v
    .progress_wrapper
      .wrapper.right
        .circle_progress.right_circle
      .wrapper.left
        .circle_progress.left_circle
      .radius_circle_wrapper
        .circle
      h2 {{ content }}
</template>

<script>
export default {
  name: "DialogLoading",
  props: {
    content: String,
  },
};
</script>

<style lang="scss" scoped>
// @import "@/assets/style/home";
* {
  box-sizing: initial;
}

$size: 120px;
$radius_width: 5px;
$duration: 1.5s;
$progress_color: #b5e3d8;
$progress_bg_color: #e3e3e3;
$text_color: #b5e3d8;

.mask {
  z-index: 1040;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

h2 {
  font-size: 1rem;
  font-weight: normal;
  color: $c-text;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
}

.loading_wrapper {
  @include rect(100%, 100%, rgba($color_white, 0.96));
  position: absolute;
  justify-content: center;
  align-items: center;
}

.progress_wrapper {
  width: $size;
  height: $size;
  position: relative;
  text-align: center;
}

.wrapper {
  width: $size / 2;
  height: $size;
  position: absolute;
  top: 0;
  overflow: hidden;
}

.right {
  right: 0;
}

.left {
  left: 0;
}

.circle_progress {
  width: $size - $radius_width * 2;
  height: $size - $radius_width * 2;
  border: $radius_width solid $progress_bg_color;
  border-radius: 50%;
  position: absolute;
  top: 0;
  transform: rotate(-135deg);
}

.right_circle {
  border-top: $radius_width solid $progress_color;
  border-right: $radius_width solid $progress_color;
  right: 0;
  animation: circleProgressRight $duration infinite linear;
  transform: rotate(45deg);
}

.left_circle {
  border-bottom: $radius_width solid $progress_color;
  border-left: $radius_width solid $progress_color;
  left: 0;
  transform: rotate(45deg);
  animation: circleProgressLeft $duration infinite linear;
}

.radius_circle_wrapper {
  width: $radius_width;
  height: 100%;
  position: relative;
  margin: auto;
  animation: radiusCircle $duration infinite linear;
}

.circle {
  width: $radius_width;
  height: $radius_width;
  border-radius: 50%;
  background-color: $progress_color;
}

.circle.static {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translatex(-50%);
}

@keyframes circleProgressLeft {
  0%,
  50% {
    transform: rotate(-135deg);
  }

  100% {
    transform: rotate(45deg);
  }
}

@keyframes circleProgressRight {
  0% {
    transform: rotate(-135deg);
  }

  50%,
  100% {
    transform: rotate(45deg);
  }
}

@keyframes radiusCircle {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 767px) {
  $size_md: 160px;

  .progress_wrapper {
    width: $size_md;
    height: $size_md;
  }

  .wrapper {
    width: $size_md / 2;
    height: $size_md;
  }

  .circle_progress {
    width: $size_md - $radius_width * 2;
    height: $size_md - $radius_width * 2;
  }

  h2 {
    font-size: 1.25rem;
  }
}
</style>
